import { createBaseAction } from '@essent/common';
import type {
  ConsentGroupType,
  GetConsentGroupResponse,
} from '@integration/api-client/consent';
import { createAction, props } from '@ngrx/store';

export const initConsentFormAction = createBaseAction<ConsentGroupType>(
  '[Consent form] Init consent form'
);

export const setConsentFormDataAction = createAction(
  '[Consent form] Set consent form data',
  props<{ consentGroup: GetConsentGroupResponse }>()
);

export const setConsentControlValues = createBaseAction<boolean>(
  '[Consent form] Set consent control values'
);
